const virtualTradingMenu = [
  {
    title: 'Trading',
    subMenu: [
      {
        label: 'Orderbook',
        link: '/orderbook',
        iconmoonWeb: 'icon-tradesmall_orderbook',
        iconmoonMobile: 'icon-menu3_orderbook',
      },
      {
        label: 'Portfolio',
        link: '/trade/portfolio',
        iconmoonWeb: 'icon-tradesmall_portfolio',
        iconmoonMobile: 'icon-menu3_portfolio',
      },
      {
        label: 'Order',
        link: '/trade/order',
        iconmoonWeb: 'icon-tradesmall_order',
        iconmoonMobile: 'icon-menu3_order',
      },
    ],
  },
];

export default virtualTradingMenu;
